import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { pick } from 'lodash-es';
import customLogger from '~/utils/logger';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useLocalization } from '~/composables/_next/useLocalization';
export var useCntfContent = function useCntfContent(id) {
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var route = useRoute();
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var result = useState("useCntfContent-".concat(id), function () {
    return null;
  });
  var loading = useState("useCntfContent-loading-".concat(id), function () {
    return false;
  });
  var error = useState("useCntfContent-error-".concat(id), function () {
    return {
      search: null
    };
  });
  var pagination = useState("useCntfContent-pagination-".concat(id), function () {
    return {
      limit: 0,
      skip: 0,
      total: 0
    };
  });
  var search = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
      var nestedFields,
        value,
        startTime,
        time,
        _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            nestedFields = _args.length > 1 && _args[1] !== undefined ? _args[1] : [];
            customLogger.info({
              id: id,
              path: route.path
            });
            loading.value = true;
            startTime = new Date().getTime();
            _context.prev = 4;
            _context.next = 7;
            return client.contentful.getEntries.query({
              params: _objectSpread({
                locale: locale
              }, params),
              nestedFields: nestedFields
            });
          case 7:
            value = _context.sent;
            pagination.value = pick(value, ['limit', 'skip', 'total']);
            result.value = value.items;
            error.value.search = null;
            _context.next = 18;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](4);
            console.warn('Request errors: ' + JSON.stringify(params) + _context.t0);
            error.value.search = _context.t0;
            console.error({
              id: id,
              path: route.path
            }, _context.t0);
          case 18:
            _context.prev = 18;
            loading.value = false;
            return _context.finish(18);
          case 21:
            time = (new Date().getTime() - startTime) / 1000;
            if (route.query.debug || time > 10) {
              console.log("UseCntfContent long response - ".concat(time, " sec with params: ").concat(JSON.stringify(params)));
            }
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 13, 18, 21]]);
    }));
    return function search(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    search: search,
    content: computed(function () {
      return result.value;
    }),
    pagination: computed(function () {
      return pagination.value;
    }),
    loading: computed(function () {
      return loading.value;
    }),
    error: computed(function () {
      return error.value;
    })
  };
};